module.exports = __webpack_public_path__ + "img/m_ddjd.34a34db1.png";